import React, { Component } from 'react'
import './DefaultPage.css'
import Envios from './Pages/Envios'
import Nosotros from './Pages/Nosotros'
import Privacidad from './Pages/Privacidad'
import Reembolso from './Pages/Reembolso'
import Terminos from './Pages/Terminos'

export default class DefaultPage extends Component {
  render() {
    const { page, storeData } = this.props

    if(page==="terminos"){
        return (
          <Terminos storeData={storeData}/>
        )
    }

    if(page==="devoluciones"){
        return (
          
            <Reembolso storeData={storeData}/>
          
        )
    }

    if(page==="envios"){
        return (
            <Envios storeData={storeData}/>
        )
    }

    if(page==="privacidad"){
        return (
            <Privacidad storeData={storeData}/>
        )
    }

    if(page==="nosotros"){
        return (
          <Nosotros storeData={storeData}/>
        )
    }

    if(page==="contacto"){
        return (
          <div>
            contacto
          </div>
        )
    }
  }
}
